<template>
  <div class="total">
    <div class="t-t">
      <div class="t-t-l">
        <div style="text-align: left">回款统计<span style="font-weight: lighter;font-size: 10px">（{{
            condition.year
          }}年{{ condition.month }}月）</span></div>
        <div><span style="font-size: 12px;color: #999">横坐标为执行时间</span></div>
      </div>
    </div>
    <div class="t-b">
      <div class="t-b-l">
        <div class="grid">
          <div class="item" @click="toDetail">
            <div class="item_main">
              <div class="num active">{{ totalData.total_count }}</div>
              <div class="desc">
                <i class="el-icon-question"/>订单总数
              </div>
            </div>
          </div>
          <div class="item" @click="toDetail">
            <div class="item_main">
              <div class="num active">{{ totalData.total_money }}</div>
              <div class="desc">
                <i class="el-icon-question"/>订单总金额（¥）
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{ totalData.total_back_money }}</div>
              <div class="desc">
                <i class="el-icon-question"/>已回款金额（¥）
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_main">
              <div class="num">{{ totalData.total_remainder_back_money }}</div>
              <div class="desc">
                <i class="el-icon-question"/>未回款金额（¥）
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="backMoneyChart"/>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getBackMoney} from "@/api/dashboard";

let myChart;

function resizeFun() {
  if (myChart)
    myChart.resize()
}

const option = {
  grid: {
    left: '5%',
    right: '3%',
    bottom: '8%',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  legend: {
    left: '10%',
    itemWidth: 15,
    itemHeight: 10,
    data: ['订单量', '订单金额', '已回款金额', '未回款金额']
  },
  xAxis: {
    axisLine: {
      lineStyle: {
        color: '#B6B6B6',
      }
    },
    data: []
  },
  yAxis: [
    {
      type: 'value',
      name: '万元',
      min: 0,
      axisLabel: {
        formatter: (value) => {
          return Number(value) / 10000
        },
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    },
    {
      type: 'value',
      name: '单',
      min: 0,
      interval: 50,
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    }
  ],
  series: [],
};

export default {
  name: "SummaryBackMoney",
  inject: ['condition'],
  data() {
    return {
      dialogCompareMonth: false,
      switchCompareMonth: false,
      option: Object.assign({}, option),
      totalData: {total_count: 0, total_money: 0, total_back_money: 0, total_remainder_back_money: 0}, //数据汇总
    }
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener('resize', resizeFun)
    this.getData()
  },
  methods: {
    getData() {
      getBackMoney(this.condition).then(res => {
        this.data = res.model;
        this.totalData.total_money = res.model.total_money || 0;
        this.totalData.total_count = res.model.total_count || 0;
        this.totalData.total_back_money = res.model.total_back_money || 0;
        this.totalData.total_remainder_back_money = res.model.total_remainder_back_money || 0;
        const xAxisData = res.model.x_data || [];
        myChart = echarts.init(document.getElementById('backMoneyChart'));
        this.switchCompareMonth = false; // 关闭对比月
        this.option.xAxis.data = xAxisData;
        this.option.legend.data = ['订单量', '订单金额', '已回款金额', '未回款金额'];
        this.option.series = [];
        const count = {
          name: '订单量',
          type: 'line',
          yAxisIndex: 1,
          data: res.model.order_count
        };
        const money = {
          name: '订单金额',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 10,
          data: res.model.order_money
        };
        const back_money = {
          name: '已回款金额',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 10,
          data: res.model.back_money
        };
        const remainder_back_money = {
          name: '未回款金额',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 10,
          data: res.model.remainder_back_money
        };
        this.option.series = [count, money, back_money, remainder_back_money]
        myChart.setOption(this.option, true)
      })
    },
    toDetail() {
      const {href} = this.$router.resolve({
        name: `dashboardOrderDetail`,
        query: {...this.condition, ...{timeType: 'exec_timestamp'}}
      });
      window.open(href, "_blank");
    }
  }
}
</script>
<style lang="scss" scoped>
.t-b {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .t-b-l {
    width: 280px;
    margin-right: 20px;
  }
}

.grid {
  font-family: FjallaOne-Regular, sans-serif !important;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 140px);
  grid-template-rows: repeat(2, 70px);
  grid-gap: 20px;

  .item {
    border-radius: 6px;
    display: flex;
    box-shadow: 0 2px 10px 0 hsla(0, 0%, 92.2%, .5);
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .item_main {
      text-align: center;

      .num {
        font-size: 18px;
        font-weight: 700;
        color: #ff3176;
      }

      .desc {
        color: #8a8e99;
      }
    }
  }
}

.total {
  height: 380px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
</style>

<style>
#backMoneyChart {
  width: calc(100% - 300px);
  height: calc(380px - 48px - 50px);
}

.order-dashboard-table thead tr, .order-dashboard-table thead th {
  background-color: #fff !important;
  color: #313337 !important;
}
</style>
